module.exports = __webpack_public_path__ + "static/couch-beca01b62396afd92456c0139e0d619d.svg";